import { render } from "./MySingleShipPricingLog.vue?vue&type=template&id=e386a764"
import script from "./MySingleShipPricingLog.vue?vue&type=script&lang=js"
export * from "./MySingleShipPricingLog.vue?vue&type=script&lang=js"

import "./MySingleShipPricingLog.vue?vue&type=style&index=0&id=e386a764&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__